import { types, query, params, rawString } from 'typed-graphqlify';
import { Types } from '@blumtechgroup/blum-ui-utils';
import { gql } from '@apollo/client';

const _selectLocationUsersInitQuery = (locationId: string) => ({
  locations_by_pk: params(
    { id: rawString(locationId) },
    {
      name: types.string,
      organisation: {
        name: types.string,
      },
    }
  ),
});

type X = Types.Unpacked<typeof _selectLocationUsersInitQuery>;
export type Location = X['locations_by_pk'];

export const selectLocationUsersInitQuery = (locationId: string) =>
  gql`
    ${query(_selectLocationUsersInitQuery(locationId))}
  `;
